import { useState, useEffect, useRef } from 'react';

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*';

/**
 * useTextScramble — scrambles text then resolves to final string.
 * @param {string} text - target text to reveal
 * @param {boolean} trigger - start animation when true
 * @param {number} duration - total animation duration in ms
 */
const useTextScramble = (text, trigger = true, duration = 1200) => {
  const [output, setOutput] = useState(text);
  const raf = useRef(null);
  const startTime = useRef(null);

  useEffect(() => {
    if (!trigger || !text) return;

    const animate = (time) => {
      if (!startTime.current) startTime.current = time;
      const elapsed = time - startTime.current;
      const progress = Math.min(elapsed / duration, 1);
      
      const revealedCount = Math.floor(progress * text.length);

      if (progress < 1) {
        const scrambled = text
          .split('')
          .map((char, i) => {
            if (char === ' ') return ' ';
            if (i < revealedCount) return char;
            return CHARS[Math.floor(Math.random() * CHARS.length)];
          })
          .join('');

        setOutput(scrambled);
        raf.current = requestAnimationFrame(animate);
      } else {
        setOutput(text);
      }
    };

    raf.current = requestAnimationFrame(animate);
    
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
      startTime.current = null;
    };
  }, [text, trigger, duration]);

  return output;
};

export default useTextScramble;
